module.exports = __webpack_public_path__ + "img/14.9.TU.078ac8e2.png";